export default {
  pm: {},
  da: {},
  eng: {},
  root: {},
  ex: {},
  exda: {}
};



// WEBPACK FOOTER //
// ./src/lang/en.js